import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredAuth = true, fallbackPath = "/login" }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px' 
      }}>
        読み込み中...
      </div>
    );
  }

  // 認証が必要な場合
  if (requiredAuth) {
    return user ? children : <Navigate to={fallbackPath} replace />;
  }

  // 認証が不要な場合（公開ページ）
  return children;
};

export default ProtectedRoute;